// Blank values are reserved for the placeholder; persisted answers are strings.
export function selectOptions(config = {}) {
  return [...new Set((Array.isArray(config.options) ? config.options : [])
    .filter(option => typeof option === "string" && option.trim() !== ""))];
}

export const selectInputTemplate = {
  type: "select-input",
  config: {
    number: "",
    prompt: "Select the correct answer.",
    points: 1,
    options: ["Option 1", "Option 2", "Option 3"],
    placeholder: "Select an answer…",
    correct: "",
    suffix: "",
  },
};
